import React from "react";
import App from './components/App';


const Root = () => {
    return (
        <App/>
    )
}

export default Root;